import { useState } from 'react';
import { testimonials, faqs } from '@/mocks/siteData';

export default function TestimonialFaqSection() {
  const [activeTab, setActiveTab] = useState<'testimonial' | 'faq'>('testimonial');
  const [openFaq, setOpenFaq] = useState(0);
  const [testimonialIndex, setTestimonialIndex] = useState(0);

  const currentTestimonial = testimonials[testimonialIndex];

  return (
    <section className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-2 mb-10 p-1 bg-background-200/60 rounded-full w-fit">
          <button
            onClick={() => setActiveTab('testimonial')}
            className={`px-5 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
              activeTab === 'testimonial'
                ? 'bg-background-50 text-foreground-950'
                : 'text-foreground-500 hover:text-foreground-800'
            }`}
          >
            瓜友证言
          </button>
          <button
            onClick={() => setActiveTab('faq')}
            className={`px-5 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
              activeTab === 'faq'
                ? 'bg-background-50 text-foreground-950'
                : 'text-foreground-500 hover:text-foreground-800'
            }`}
          >
            常见问题
          </button>
        </div>

        {activeTab === 'testimonial' && (
          <div className="relative bg-foreground-950 rounded-3xl overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="relative h-64 lg:h-auto">
                <img
                  src={currentTestimonial.image}
                  alt={currentTestimonial.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8 md:p-12 lg:p-14 flex flex-col justify-center">
                <span className="text-accent-300 text-7xl md:text-8xl font-serif leading-none mb-4">"</span>
                <blockquote className="text-background-50/90 text-base md:text-lg leading-relaxed mb-8">
                  {currentTestimonial.quote}
                </blockquote>
                <div>
                  <p className="text-background-50 font-heading font-bold text-lg">{currentTestimonial.name}</p>
                  <p className="text-foreground-400 text-sm mt-1">{currentTestimonial.role}</p>
                </div>
                <div className="flex items-center gap-3 mt-8">
                  {testimonials.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setTestimonialIndex(i)}
                      className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                        i === testimonialIndex ? 'bg-accent-500 w-7' : 'bg-foreground-600 hover:bg-foreground-400'
                      }`}
                    />
                  ))}
                  <div className="flex gap-2 ml-auto">
                    <button
                      onClick={() => setTestimonialIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1))}
                      className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-foreground-600 text-background-50 transition-colors cursor-pointer"
                    >
                      <i className="ri-arrow-left-line text-sm"></i>
                    </button>
                    <button
                      onClick={() => setTestimonialIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1))}
                      className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-foreground-600 text-background-50 transition-colors cursor-pointer"
                    >
                      <i className="ri-arrow-right-line text-sm"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'faq' && (
          <div className="space-y-3 max-w-3xl">
            {faqs.map((faq, i) => (
              <div key={i} className="rounded-2xl bg-background-50 border border-background-200/50 overflow-hidden">
                <button
                  onClick={() => setOpenFaq(openFaq === i ? -1 : i)}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
                >
                  <span className="font-heading font-bold text-foreground-950 text-sm md:text-base pr-4">{faq.question}</span>
                  <i
                    className={`text-foreground-400 text-lg transition-transform duration-300 flex-shrink-0 ${
                      openFaq === i ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openFaq === i ? 'max-h-96 pb-5 px-5 md:px-6' : 'max-h-0'
                  }`}
                >
                  <p className="text-foreground-600 text-sm leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}